import { render, staticRenderFns } from "./notFound.vue?vue&type=template&id=64b260ec&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b260ec",
  null
  
)

export default component.exports